import { MapEvent } from './map-event';
import { MapEventType } from './map-event-type';

export class MapZoomEndEvent implements MapEvent {
    type: MapEventType = MapEventType.mapZoomEnd;

    constructor(
        public payload: mapboxgl.MapboxEvent<
            MouseEvent | TouchEvent | WheelEvent
        > &
            mapboxgl.EventData
    ) {}
}
